import {useState, useEffect, useRef} from 'react';

import {useDispatch} from 'react-redux';
import {actionCreators} from '../../../store';

import {ActionType} from '../../../store/actionTypes';

import {history} from '../../../helpers/history';
import {useTypedSelector} from '../../../hooks/useTypeSelector';

import ButtonLoader, {IButtonLoaderRef} from '../../../com/buttonLoader/ButtonLoader';

import {LoginDto, UserDto} from '../../../dtos';

import PasswordInput from '../../../com/passwordInput/PasswordInput';

import TextInput from '../../../com/textInput/TextInput';

import {getVariableName} from '../../../helpers/utils';
import validator from "validator";

import './SigninForm.scss';
import {Box, Typography} from "@mui/material";
// import {ReactComponent as EmailIcon} from "./../../../assets/email_icon.svg";
import {makeStyles} from "@mui/styles";
// import {makeStyles, Theme} from "@material-ui/core";

const useStyles = makeStyles(() => ({
    formWrapper: {
        width: "100%"
    },
    textEventsWrapper: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "20px"
    },
    textEventBox: {
        display: "flex",
        flexFlow: "column",
        rowGap: "4px",
        "& > .MuiTypography-root": {
            fontSize: "14px"
        }
    },
    emailIconWrapper: {
        display: `flex`,
        justifyContent: `center`,
        alignItems: `center`,
        marginTop: `20px`
    },
    emailIcon: {
        padding: `20px`,
        borderRadius: `50%`,
        backgroundColor: `#263EB91A`
    }
}))

interface ISigninForm {
    onForgotPasswordClick: () => void;
    onRegisterClick: () => void;
}

const SigninForm: React.FC<ISigninForm> = (props) => {

    // const {projectName} = useParams<IAuthParamsDto>();

    const [emailAddress, setEmailAddress] = useState('');
    const [password, setPassword] = useState('');

    // for testing
    // const [userName, setUsername] = useState('johny');
    // const [password, setPassword] = useState('123456');

    const [errors, setErrors] = useState({
        emailAddress: '',
        password: '',
    });

    const hooksNames: string[] = [
        getVariableName({emailAddress}),
        getVariableName({password}),
    ];

    const dispatch = useDispatch();

    let buttonLoaderRef = useRef<IButtonLoaderRef>(null);

    const {loading, type} = useTypedSelector((state) => state.auth);
    const classes = useStyles();

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!isFormdValid()) {
            return;
        }

        let loginDto: LoginDto = {
            emailAddress,
            password
        }

        buttonLoaderRef.current?.showLoader(true);

        dispatch(actionCreators.login(loginDto));
    }

    const isFormdValid = () => {

        let allErrors = validate();

        // if length === 0 => true
        // else false
        return Object.values(allErrors).join('').length === 0;
    }

    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>, hookName: string, hookFunction: React.Dispatch<React.SetStateAction<any>>) => {
        var value = event.target.value;
        hookFunction(value);

        validate(hookName, value);
    }

    const validate = (hookName?: string, enforceValue?: any) => {

        let allErrors: any = {...errors}
        hooksNames.forEach(name => {
            let currentError = validateInput(name, enforceValue);

            if (hookName) {
                // validate only 1 input
                if (name === hookName) {
                    allErrors[name] = currentError;
                }
            } else {
                // validate all inputs
                allErrors[name] = currentError;
            }
        });

        setErrors(allErrors);

        return allErrors;
    }

    const validateInput = (name: string, enforceValue?: any) => {

        let value = null;
        let err = '';

        if (enforceValue === undefined) {
            switch (name) {
                case getVariableName({emailAddress}):
                    value = enforceValue ? enforceValue : emailAddress;
                    const isValidEmail = validator.isEmail(value);
                    err = !isValidEmail
                        ? 'Email address is wrong'
                        : ''
                    break;

                case getVariableName({password}):
                    // value = enforceValue;
                    value = enforceValue ? enforceValue : password
                    err = value.length < 6
                        ? 'Password must be at least 6 characters'
                        : ''
                    break;
            }
        }

        return err;
    }

    const delay = 500;

    useEffect(() => {
        if (type === ActionType.LOGIN_SUCCESS) {
            setTimeout(() => {
                const userDto = localStorage.getItem('userDto');
                if (userDto) {
                    history.push('/flyersCatalog');
                }
            }, delay);
        }
    })

    useEffect(() => {
        if (!loading) {
            setTimeout(() => {
                buttonLoaderRef.current?.showLoader(false);
            }, delay);
        }
    }, [loading])

    return (
        <div className={classes.formWrapper}>
            {/*<Box className={classes.emailIconWrapper}>*/}
            {/*    <Box className={classes.emailIcon}>*/}
            {/*        <EmailIcon/>*/}
            {/*    </Box>*/}
            {/*</Box>*/}
            <Typography
                sx={{
                    fontSize: "28px",
                    textAlign: "center",
                    marginBottom: "32px",
                    fontWeight: 500
                }}
            >
                Sign In
            </Typography>

            <form className="auth_item_container_form" noValidate onSubmit={onSubmit}>
                <Box>
                    <TextInput
                        placeHolder="Work Email Address"
                        type="email"
                        value={emailAddress}
                        onChange={e => onInputChange(e, getVariableName({emailAddress}), setEmailAddress)}
                        errorMessage={errors.emailAddress}
                        isRequired={true}
                    />
                </Box>
                <Box>
                    <PasswordInput
                        value={password}
                        onChange={e => onInputChange(e, getVariableName({password}), setPassword)}
                        errorMessage={errors.password}
                    />

                </Box>
                <ButtonLoader ref={buttonLoaderRef}>
                    SIGN IN
                </ButtonLoader>
                <Box className={classes.textEventsWrapper}>
                    <Box className={classes.textEventBox}>
                        <Typography color={"#828282"}>
                            Forgot Password?
                        </Typography>
                        <Typography onClick={props.onForgotPasswordClick} fontWeight={500}
                                    sx={{
                                        textDecoration: "underline",
                                        cursor: "pointer"
                                    }}
                        >
                            Click here
                        </Typography>
                    </Box>
                    <Box className={classes.textEventBox}>
                        <Typography color={"#828282"}>
                            Not registered yet?
                        </Typography>
                        <Typography onClick={props.onRegisterClick} fontWeight={500}
                                    sx={{
                                        textDecoration: "underline",
                                        cursor: "pointer"
                                    }}
                        >
                            Register here
                        </Typography>

                    </Box>
                </Box>

                {/*<AuthPrivacy/>*/}


                {/*
                <div>
                    <p>New to xCircular?</p>
                    <div onClick={props.onRegisterClick}>Register Free</div>
                </div>
*/}
            </form>
        </div>
    )
}

export default SigninForm;
